import { render, staticRenderFns } from "./quesScale.vue?vue&type=template&id=1dbcbc3c&scoped=true&"
import script from "./quesScale.vue?vue&type=script&lang=js&"
export * from "./quesScale.vue?vue&type=script&lang=js&"
import style0 from "./quesScale.vue?vue&type=style&index=0&id=1dbcbc3c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbcbc3c",
  null
  
)

export default component.exports